function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.5a9.5 9.5 0 100 19 9.5 9.5 0 000-19zM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12zm6 0a.5.5 0 01.5-.5h3.5V8a.5.5 0 011 0v3.5H16a.5.5 0 010 1h-3.5V16a.5.5 0 01-1 0v-3.5H8a.5.5 0 01-.5-.5z",
  fill: "#1A1C21"
});

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgPlus;